/**
 * 公共数据
 */

import BaseAuthClient from './baseAuth';

class CommClient extends BaseAuthClient {
  constructor() {
    super({ baseURL: '/api' });
  }
}

const commClient = new CommClient();

export default commClient;

// 获取全局基础配置类型
export const getBaseConfig = (option: any) => commClient.get(`/v1/common/getconfig`, option);
